/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 14:17:24
 * @LastEditors: sj
 * @LastEditTime: 2022-06-07 15:38:10
 */
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { RootDispatch } from '../../../../app/store'
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  notification,
  Space,
} from 'antd'
import { useDispatch } from 'react-redux'
import { ThemeContext } from '../../../../theme/ThemeContext'
import {
  DateSelect as DateSelectOne,
  SelectTime,
} from '../../../../compnents/date/TimeSelect'
import { Chart } from '@antv/g2'
import { getReplaceMakeSupplierList } from '../../../replaceMakeCenter/ReplaceMakeSupplierSclice'
import { unwrapResult } from '@reduxjs/toolkit'
import { getTenantList } from '../../../tenant/tenantSlice'
import { getReplaceMakeOrderStatisticAnalysis } from '../../StatisticSlice'

// 数据统计
export const Statistics = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [supplierNameOptions, setSupplierNameOptions] = useState<any>([]) // 饮片厂下拉选

  const [hospitalNameOptions, setHospitalNameOptions] = useState<any>([]) // 机构下拉选

  const [chartData, setChartData] = useState<any>([])

  const updateState = [
    {
      value: 0,
      label: '未上传',
    },
    {
      value: 1,
      label: '已上传',
    },
    {
      value: 2,
      label: '取消',
    },
    {
      value: -1,
      label: '全部',
    },
  ]

  const timeOptions = [{
    value: 3,
    label: '近30天',
  }, {
    value: 2,
    label: '近12个月',
  }, {
    value: 1,
    label: '近3年',
  },]

  useEffect(() => {
    getSupplierNameOptions()
    getHospitalNameOptions()
    // dispatch(getReplaceMakeOrderStatisticAnalysis({}))
  }, [])

  const getSupplierNameOptions = (val = '') => {
    dispatch(getReplaceMakeSupplierList({
      size: 10,
      current: 1,
      name: val,
    })).then(unwrapResult).then((res: any) => {
      setSupplierNameOptions(res.records.map((el: any) => {
        return {
          value: el.id,
          label: el.name
        }
      }))
    })
  }

  const getHospitalNameOptions = (val = '') => {
    dispatch(getTenantList({
      size: 10,
      current: 1,
      name: val,
      openType: 0
    })).then(unwrapResult).then((res: any) => {
      setHospitalNameOptions(res.items.map((el: any) => {
        return {
          value: el.id,
          label: el.name
        }
      }))
    })
  }
  const [chart, setchart] = useState<any>()
  useEffect(() => {

    if (chartData.length) {
      setchart(new Chart({
        container: 'container',
        autoFit: true,
        height: 500,
      }))
    }

  }, [chartData])

  useEffect(() => {
    if (chartData.length) {
      chart.data(chartData)
      chart.scale('data', {
      nice: true,
    })
    chart.tooltip({
      showMarkers: false,
      shared: true,
    })
    chart.legend({
      position: 'top',
    })
    chart
      .interval()
      .position('time*data')
      .color('name')
      .adjust([
        {
          type: 'dodge',
          marginRatio: 0,
        },
      ])

    chart.interaction('element-highlight-by-x')
    chart.interaction('legend-highlight')
      chart.interaction('active-region')
    chart.render()
    }

  }, [chart])

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '20px 25px',
          display: 'flex',
          height: 80,
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          name='control-hooks'
          autoComplete='off'
          initialValues={
            {
              flag: 3,
              status: -1
            }
          }
          onFinish={(values) => {
            chart && chart.destroy()
            console.log(Object.entries(form.getFieldsValue()))
            dispatch(getReplaceMakeOrderStatisticAnalysis({ ...values, platformId: 1 })).then(unwrapResult).then((res: any) => {
              const money: any = []
              const count: any = []
              res.forEach((v: any) => {
                money.push({
                  name: '订单总金额(元)',
                  time: v.time,
                  data: v.allMoney
                })
                count.push({
                  name: '订单数量(笔)',
                  time: v.time,
                  data: v.allCount
                })
              })
              setChartData([...money, ...count])

            })
          }}
          style={{ marginTop: 20 }}
        >
          <Row
            gutter={11}
            style={{ height: '40px', justifyContent: 'space-between' }}
          >
            <Space>
              <Form.Item
                name='flag'
                noStyle
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder='上传时间'
                  style={{ width: 220 }}
                >
                  {timeOptions.map((c) => (
                    <Select.Option key={c.value} value={c.value}>
                      上传时间-{c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name='supplierId'
                noStyle
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder='代煎饮片厂名称/助记码'
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  notFoundContent={null}
                  style={{ width: 220 }}
                  allowClear
                  onSearch={val => {
                    getSupplierNameOptions(val)
                  }}
                >
                  {supplierNameOptions?.map((c: any) => (
                    <Select.Option key={c.value} value={c.value}>
                      {c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name='tenantId'
                noStyle
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder='机构名称/助记码'
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  notFoundContent={null}
                  style={{ width: 220 }}
                  allowClear
                  onSearch={val => {
                    getHospitalNameOptions(val)
                  }}
                >
                  {hospitalNameOptions?.map((c: any) => (
                    <Select.Option key={c.value} value={c.value}>
                      {c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name='status'
                noStyle
              >
                <Select
                  placeholder='上传状态'
                  style={{ width: 220 }}
                >
                  {updateState.map((c) => (
                    <Select.Option key={c.value} value={c.value}>
                      上传状态-{c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Space>
            <Button
              htmlType='submit'
              type='primary'
              style={{ marginRight: 30 }}
              onClick={() => {
                form
                  .validateFields()
                  .then(() => {
                    form.submit
                  })
                  .catch(() => {
                    notification.error({
                      message: '请完善查询条件',
                      duration: 3,
                    })
                  })
              }}
            >
              查询
            </Button>
          </Row>
        </Form>
        <div
          id='container'
          style={{ backgroundColor: '#FFF', padding: '30px 50px', flex: '1' }}
        ></div>
      </Col>
    </Col>
  )
}

export default Statistics
